import { useDispatch } from "react-redux";
import { setBackdropLoader } from "./backdropLoaderSlice";

export default function BackdropLoaderService() {
  const dispatch = useDispatch();

  const open = () => {
    dispatch(setBackdropLoader({ open: true, reload: false }));
  };

  const close = () => {
    dispatch(setBackdropLoader({ open: false, reload: false }));
  };

  const closeReload = () => {
    dispatch(setBackdropLoader({ open: false, reload: true }));
  };

  return {
    open,
    close,
    closeReload,
  };
}
